import React from "react";
import styles from "./Filters.module.scss";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Arrow from "../../../assets/img/arrow_r_small.png";
import Button from "@material-ui/core/Button";
import api from "../../../services/Api";
import CheckboxIcon from "../../../assets/img/checkbox.png";
import CheckboxCheckedIcon from "../../../assets/img/checkboxChecked2.png";

import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import pl from "date-fns/locale/pl";
import Fade from "@material-ui/core/Fade";

class Filters extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      domains: null,
      showAll: false,
      lawyerStatuses: null,
      startDate: null,
      endDate: null,
    };
  }

  componentDidMount() {
    api.get("lawyerStatuses").then((response) => {
      if (response.status === 200 && response.data.success === true) {
        this.setState({
          lawyerStatuses: response.data.data,
        });
      }
    });
  }

  showMore = () => {
    this.setState({
      showAll: !this.state.showAll,
    });
  };

  setStartTime = (e) => {
    this.setState({
      startDate: e,
    });

    this.props.setDateFrom(e);
  };

  setEndTime = (e) => {
    this.setState({
      endDate: e,
    });

    this.props.setDateTo(e);
  };

  render() {
    const { showAll, lawyerStatuses } = this.state;
    const { domains } = this.props;
    const { setDomainFilter, setStatusFilter, currentDomain, currentStatus } =
      this.props;

    let no = 0;

    return (
      <Fade in={true} timeout={800}>
        <div className={styles.Filters}>
          <div className={styles.domains}>
            <h3>
              Dziedziny <strong>prawa</strong>
            </h3>
            {domains &&
              domains.map((domain) => {
                no++;
                if (showAll || (!showAll && no <= 10))
                  return (
                    <div>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={currentDomain == domain.id}
                            name={domain.name}
                            icon={<img src={CheckboxIcon} alt="checkbox" />}
                            checkedIcon={
                              <img src={CheckboxCheckedIcon} alt="checkbox" />
                            }
                          />
                        }
                        label={domain.name}
                        onChange={() => {
                          setDomainFilter(domain.id, domain.name);
                        }}
                      />
                    </div>
                  );
              })}

            {domains && (
              <span className={styles.showMore} onClick={this.showMore}>
                {showAll ? "Ukryj" : "Zobacz więcej"}{" "}
                <img src={Arrow} alt="Arrow" />
              </span>
            )}
          </div>

          <div className={styles.deadlines}>
            <h3>
              Wolne <strong>terminy</strong>
            </h3>
            <div className={styles.subtitle}>Wpisz zakres dat</div>

            <div className={styles.dinputs}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={pl}>
                <KeyboardDatePicker
                  className={styles.datePicker}
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  format="dd/MM/yyyy"
                  margin="normal"
                  value={this.state.startDate}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  onChange={this.setStartTime}
                  autoOk
                  placeholder="Od"
                  minDate={new Date()}
                />
                <KeyboardDatePicker
                  className={styles.datePicker}
                  disableToolbar
                  variant="inline"
                  inputVariant="outlined"
                  format="dd/MM/yyyy"
                  margin="normal"
                  value={this.state.endDate}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                  onChange={this.setEndTime}
                  autoOk
                  placeholder="Do"
                  minDate={new Date()}
                />
              </MuiPickersUtilsProvider>
              {/*<input type="text" name="Od" placeholder="od"/>*/}
              {/*<input type="text" name="Do" placeholder="do"/>*/}
            </div>
          </div>

          <div className={styles.status}>
            <h3>
              Rodzaj <strong>wyników</strong>
            </h3>

            {lawyerStatuses &&
              lawyerStatuses.map((status) => {
                return (
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={currentStatus === status.name}
                        icon={<img src={CheckboxIcon} alt="checkbox" />}
                        checkedIcon={
                          <img src={CheckboxCheckedIcon} alt="checkbox" />
                        }
                      />
                    }
                    label={status.name}
                    onChange={() => {
                      setStatusFilter(status.name);
                    }}
                  />
                );
              })}
          </div>

          <div className={styles.applyContainer}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.props.setBoxContent(false)}
            >
              Zastosuj
            </Button>
          </div>
        </div>
      </Fade>
    );
  }
}

Filters.defaultProps = {};

export default Filters;
